import { ParkiteReportService } from './../services/parkite-report.service';
import { InviteService } from './../services/invite.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { DateService } from './../services/date.service';
import { AppStateProvider } from './../services/app-state.provider';
import { DatePipe } from '@angular/common';
import { Component, Injectable, NgZone, OnInit } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from '../services/report.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { APIs } from 'src/app/config/api.constant';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { EventsService } from '../services/events.service';
import { environment } from '../../environments/environment';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}
@Component({
  standalone: false,
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})

export class ReportsComponent implements OnInit {
  model;
  worksheet;
  workbook;
  searchText: string = '';
  meetingNav: { index: string; name: string; link: string }[];
  isDesc: boolean = false;
  column: string = 'MeetingRoom';
  selectedDate: any;
  selectedIndex: number;
  selectedMeetingRoomId: any;
  selectedDepartmentId: any;
  selectedTenantId;
  selectedOrganizationId: any;
  selectedAccessPointId: any;
  selectedMeetingRoom: any;
  selectedOrganzation: any;
  selectedUsageType: any;
  selectedFRType: any;
  selectedDepartment: any;
  selectedAccessPoint: any;
  selectedToDate: any;
  meetingRooms: any;
  accessPoints: any;
  departments: any;
  tenants: any;
  tenantsrfids: any;
  creditPoints: any = [];
  checkIns: any = [];
  checkIn: any = [];
  employees: any = [];
  meetings: any = [];
  meeting: any = [];
  memberships: any;
  listfrids: any;
  listSurvey: any;
  listFacility: any;
  listEmployee: any;
  toDate: any;
  fromDate: any;
  EXCEL_EXTENSION = '.xlsx';
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  reportsFetched: boolean = false;
  reportsLoaded: boolean = false;
  multiSelectionMeetingRoom: any = [];
  Usagetypes: any = [];
  FRtypes: any = [];
  DownloadTypes: any = [];
  SelectedDownloadReportType: any = [];
  page: any = 1;
  multiSelectionDepartments: any = [];
  multiSelectionOrganizations: any = [];
  multiSelectionAccessPoints: any = [];
  multiSelectionCreditUsageType: any = [];
  multiSelectionFRType: any = [];
  meetingRoom: any;
  pageSize: number = 10;
  department: any;
  accessPoint: any;
  creditPoint: any;
  employee: any;
  selctionlength: number;
  PdfReportrows = [];
  hour: any;
  min: any;
  time: string;
  meridiem: string;
  fromDetails: boolean = false;
  frmDate: { year: number; month: number; day: number };
  fDate: any;
  tDate: string;
  formattedSelectedDate: string = '';
  formattedSelectedToDate: string = '';
  queryData: any;
  invitationTypes: any;
  selectedInvitatoinTypeId: any;
  selectedEventTypeId: any;
  multiSelectionInvitationType: any[] = [];
  multiSelectionEventType: any[] = [];
  selectedType: any;
  selectedEType: any;
  vmsList: any = [];
  totalRows: any;
  vmsLists: any = [];
  totalVMSCount: any;
  eventType
  eventList
  totalEventCount = 0
  prod: boolean = false;
  mainSurveyTypes = [];
  mainFacilityTypes = [];
  mainEmployeeTypes = [];
  selectedSurveyName: any;
  selectedFacilityName: any;
  selectedEmployeeName: any;
  tempDate: any;
  indexPage = 1;
  buildingData: any;
  tenantData: any;
  baseUrl;
  employeesList: any[] = [];
  pageNo: number = 1;

  constructor(
    public datepipe: DatePipe,
    private reportService: ReportService,
    private appStateSrv: AppStateProvider,
    public calendar: NgbCalendar,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService,
    private sideNavService: SidenavService,
    private vmsService: ParkiteReportService,
    private eventService: EventsService,
  ) {
    if (window.location.host == 'csworkind-cla-prod.capitaland.com') {
      this.prod = true
    }
    else {
      this.prod = false
    }
    this.DownloadTypes = [
      { id: '1', type: 'Download as PDF' },
      { id: '2', type: 'Download as Excel' },
    ];
    ngbDatepickerConfig.minDate = {
      year: 1970,
      month: 1,
      day: 1,
    };

    ngbDatepickerConfig.outsideDays = 'visible';
  }

  downloadFeedbackReport() {
    return (
      APIs.getFeedbakReport +
      '/' +
      this.selectedFRType.replace(' ', '') +
      '?FromDate=' +
      this.datepipe.transform(this.fromDate, 'MM/dd/yyyy')
    );
    // this.reportService.getFeedBackReport(APIs.getFeedbakReport + '/' + this.selectedFRType.replace(" ", '') + '?FromDate=' + this.datepipe.transform(this.fromDate, 'dd/MM/yyyy')).subscribe();
  }

  public async updateSelectedDate(date: NgbDate) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.fromDate = jsDate;
    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );

    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        if (this.selectedIndex == 0) {
          this.getCreditReports(this.multiSelectionCreditUsageType[0]);
        }
        if (this.selectedIndex == 1) {
          this.getCheckInReports();
        } else if (this.selectedIndex == 2) {
          this.getMembershipsReport();
        } else if (this.selectedIndex == 3) {
          this.getMeetingReports();
        } else if (this.selectedIndex == 4) {
          this.getMeetingReports();
        } else if (this.selectedIndex == 6) {
          this.page = 1
          this.getVMSReports();
        } else if (this.selectedIndex == 7) {
          this.page = 1;
          this.getEventsReports();
        } else if (this.selectedIndex == 8) {
          // this.page = 1;
          this.getRfidsReport();
        } else if (this.selectedIndex == 9) {
          // this.page = 1;
          this.getSurveyReport();
        } else if (this.selectedIndex == 10) {
          // this.page = 1;
          this.getFacilityReport();
        } else if (this.selectedIndex == 11) {
          // this.page = 1;
          this.getEmployeeReportData();
        }
      } else {
        this.selectedDate = this.convertDateFormat(this.datepipe.transform(new Date(), 'MM/dd/yyyy'));
        this.selectedToDate = this.convertDateFormat(this.datepipe.transform(new Date(), 'MM/dd/yyyy'));
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        // this.resetDate(localStorage.getItem("temp"));

        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.selectedReportType(this.selectedIndex);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public async updateSelectedToDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;
    this.selectedToDate = this.convertDateFormat(this.datepipe.transform(jsDate, 'MM/dd/yyyy'));
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        if (this.selectedIndex == 0) {
          this.getCreditReports(this.multiSelectionCreditUsageType[0]);
        }
        if (this.selectedIndex == 1) {
          this.getCheckInReports();
        } else if (this.selectedIndex == 2) {
          this.getMembershipsReport();
        } else if (this.selectedIndex == 3) {
          this.getMeetingReports();
        } else if (this.selectedIndex == 4) {
          this.getMeetingReports();
        } else if (this.selectedIndex == 6) {
          this.page = 1;
          this.getVMSReports();
        } else if (this.selectedIndex == 7) {
          this.page = 1;
          this.getEventsReports();
        } else if (this.selectedIndex == 8) {
          // this.page = 1;
          this.getRfidsReport();
        } else if (this.selectedIndex == 9) {
          // this.page = 1;
          this.getSurveyReport();
        } else if (this.selectedIndex == 10) {
          // this.page = 1;
          this.getFacilityReport();
        } else if (this.selectedIndex == 11) {
          // this.page = 1;
          this.getEmployeeReportData();
        }
      } else {
        this.selectedToDate = this.convertDateFormat(this.datepipe.transform(new Date(), 'MM/dd/yyyy'));
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy')
        // this.tDate = this.fDate
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        // this.resetDate(localStorage.getItem("temp"));

        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.selectedReportType(this.selectedIndex);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  sort(property, list) {
    this.isDesc = !this.isDesc; //change the direction
    this.column = property;
    let direction = this.isDesc ? 1 : -1;

    let sortedArray = list.sort(function (a, b) {
      if (a[property] < b[property]) {
        return -1 * direction;
      } else if (a[property] > b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
    return sortedArray;
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }

    // if (this.selectedIndex == 1) {
    //   this.getAccessPoints();
    //   this.getCheckInReports();
    // }
    // else if (this.selectedIndex == 2) {
    //   this.getDepartments();
    //   this.getEmployeeReports();
    // }
    // else if (this.selectedIndex == 3) {
    //   this.getMeetingRooms();
    //   this.getMeetingReports();
    // }
    // else if (this.selectedIndex == 4) {
    //   this.getCreditReports();
    // }
  }

  /**
   * Reset pagination to page 1 when search text changes so the filtered list shows from the first page.
   */
  onReportSearchChange(): void {
    this.page = 1;
    this.indexPage = 1;
    if (this.selectedIndex === 8) {
      this.pageNo = 1;
    }
  }

  selectedReportDownload(item) {
    this.SelectedDownloadReportType = [];
    if (item.id !== null) {
      this.SelectedDownloadReportType.push(item.id);
    } else {
      this.SelectedDownloadReportType.push(1);
    }
    if (item.id == 2) {
      this.DownloadReport();
    } else if (item.id == 1) {
      this.DownloadReportPDF();
    }
  }

  selectedReportType(item) {
    // console.log(item); return
    this.searchText = '';
    this.totalEventCount = 0;
    this.totalVMSCount = 0;
    this.page = 1;
    this.selectedIndex = item;
    this.pageNo = 0;
    if (this.selectedIndex == 1) {
      this.resetDate(1);
      this.getAccessPoints();
      this.getCheckInReports();
    } else if (this.selectedIndex == 2) {
      this.resetDate(2);
      this.getTentants();
      this.getMembershipsReport();
    } else if (this.selectedIndex == 8) {
      this.resetDate(8);
      this.getTentantsRfid();
      this.getRfidsReport();
    } else if (this.selectedIndex == 9) {
      this.resetDate(9);
      this.getSurveyReport();
      this.getTypeSurvey();
    } else if (this.selectedIndex == 10) {
      this.resetDate(10);
      this.getFacilityReport();
      this.getTypeFacility();
    } else if (this.selectedIndex == 11) {
      this.resetDate(11);
      this.getTypeEmployeeReport();
      this.getEmployeeReportData();
    } else if (this.selectedIndex == 3) {
      this.resetDate(3);
      this.getMeetingRooms();
      this.getMeetingReports();
    } else if (this.selectedIndex == 4) {
      this.resetDate(4);
      this.multiSelectionMeetingRoom = [];
      this.getMeetingRooms();
      this.getMeetingReports();
    } else if (this.selectedIndex == 6) {
      this.resetDate(6);
      this.multiSelectionInvitationType = [];
      this.getinvitationTypes();
      this.getVMSReports();
    } else if (this.selectedIndex == 0) {
      this.resetDate(0);
      this.multiSelectionCreditUsageType = [];
      this.Usagetypes = [
        { id: '1', type: 'Admin(s)' },
        { id: '3', type: 'Members' },
      ];
      this.multiSelectionCreditUsageType.push(this.Usagetypes[0].id);
      // this.selectedAccessPointId = item.id;
      // this.selctionlength=this.multiSelectionCreditUsageType.length-1
      this.selectedUsageType = this.Usagetypes[0].type;
      this.getCreditReports(1);
    } else if (this.selectedIndex == 5) {
      this.resetDate(5);
      this.FRtypes = [
        { id: '1', type: 'Meeting Room' },
        { id: '2', type: 'Employee De-Boarding' },
        { id: '3', type: 'Organisation De-Boarding' },
      ];
      this.multiSelectionFRType.push(this.FRtypes[0].id);

      this.selectedFRType = this.FRtypes[0].type;
    } else if (this.selectedIndex == 7) {

      this.getEventType();
      this.getEventsReports();
    }
  }

  selectAccessPoint(item) {
    if (item.id !== null)
      if (this.multiSelectionAccessPoints.includes(item.id))
        this.multiSelectionAccessPoints.splice(
          this.multiSelectionAccessPoints.indexOf(item.id),
          1
        );
      else this.multiSelectionAccessPoints.push(item.id);
    else this.multiSelectionAccessPoints = [];

    this.selctionlength = this.multiSelectionAccessPoints.length - 1;
    this.selectedAccessPointId = item.id;

    if (item.department != 'All') {
      this.selectedAccessPoint = this.accessPoints.find(
        (x) =>
          x.id ==
          this.multiSelectionAccessPoints[
          this.multiSelectionAccessPoints.length - 1
          ]
      ).accessPointName;
    } else {
      this.selectedAccessPoint = item.accessPointName;
    }
    console.log(this.multiSelectionAccessPoints);
    this.getCheckInReports();
  }
  selectCreditUsage(item) {
    this.searchText = '';
    this.multiSelectionCreditUsageType = [];
    if (item.id !== null) {
      this.multiSelectionCreditUsageType.push(item.id);
    } else this.multiSelectionCreditUsageType.push(1);
    // this.selectedAccessPointId = item.id;
    // this.selctionlength=this.multiSelectionCreditUsageType.length-1
    this.selectedUsageType = item.type;
    this.getCreditReports(item.id);
  }

  selectFR(item) {
    this.multiSelectionFRType = [];
    if (item.id !== null) {
      this.multiSelectionFRType.push(item.id);
    } else this.multiSelectionFRType.push(1);
    this.selectedFRType = item.type;
  }

  selectET(item) {
    this.multiSelectionEventType = [];
    if (item.id !== null) {
      this.multiSelectionEventType.push(item.id);
    } else this.multiSelectionEventType.push(1);
    this.selectedFRType = item.type;
  }

  selectDepartment(item) {
    if (item.id !== null)
      if (this.multiSelectionDepartments.includes(item.id))
        this.multiSelectionDepartments.splice(
          this.multiSelectionDepartments.indexOf(item.id),
          1
        );
      else this.multiSelectionDepartments.push(item.id);
    else this.multiSelectionDepartments = [];

    //console.log('multiSelectionDepartments', this.multiSelectionDepartments);
    let length = this.multiSelectionDepartments.length - 1;
    this.selctionlength = length;
    this.selectedDepartmentId = item.id;
    if (item.department != 'All') {
      this.selectedDepartment = this.departments.find(
        (x) =>
          x.id ==
          this.multiSelectionDepartments[
          this.multiSelectionDepartments.length - 1
          ]
      ).department;
    } else {
      this.selectedDepartment = item.department;
    }

    this.getEmployeeReports();
  }

  selectMeetingRoom(item) {
    console.log(item, 'item');

    if (item.id !== null)
      if (this.multiSelectionMeetingRoom.includes(item.id))
        this.multiSelectionMeetingRoom.splice(
          this.multiSelectionMeetingRoom.indexOf(item.id),
          1
        );
      else this.multiSelectionMeetingRoom.push(item.id);
    else this.multiSelectionMeetingRoom = [];

    let length = this.multiSelectionMeetingRoom.length - 1;
    this.selctionlength = length;
    this.selectedMeetingRoomId = item.id;
    if (item.name != 'All') {
      this.selectedMeetingRoom = this.meetingRooms.find(
        (x) =>
          x.id ==
          this.multiSelectionMeetingRoom[
          this.multiSelectionMeetingRoom.length - 1
          ]
      ).name;
    } else {
      this.selectedMeetingRoom = item.name;
    }
    this.getMeetingReports();
  }

  selectOrgatization(item) {
    if (item.id !== null)
      if (this.multiSelectionOrganizations.includes(item.id))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.id),
          1
        );
      else this.multiSelectionOrganizations.push(item.id);
    else this.multiSelectionOrganizations = [];

    let length = this.multiSelectionOrganizations.length - 1;
    this.selctionlength = length;
    this.selectedOrganizationId = item.id;
    this.selectedOrganzation = item.companyName;

    if (item.name != 'All') {
      this.selectedOrganzation = this.tenants.find(
        (x) =>
          x.id ==
          this.multiSelectionOrganizations[
          this.multiSelectionOrganizations.length - 1
          ]
      ).companyName;
    } else {
      this.selectedOrganzation = item.companyName;
    }

    this.getMembershipsReport();
  }

  selectOrgatizationRfid(item) {
    if (item.id !== null)
      if (this.multiSelectionOrganizations.includes(item.id))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.id),
          1
        );
      else this.multiSelectionOrganizations.push(item.id);
    else this.multiSelectionOrganizations = [];

    let length = this.multiSelectionOrganizations.length - 1;
    this.selctionlength = length;
    this.selectedOrganizationId = item.id;
    this.selectedOrganzation = item.companyName;

    if (item.name != 'All') {
      this.selectedOrganzation = this.tenants.find(
        (x) =>
          x.id ==
          this.multiSelectionOrganizations[
          this.multiSelectionOrganizations.length - 1
          ]
      ).companyName;
    } else {
      this.selectedOrganzation = item.companyName;
    }

    this.getRfidsReport();
  }

  selectOrgatizationSurvey(item) {
    console.log(item);
    if (item.surveyTypeId !== null)
      if (this.multiSelectionOrganizations.includes(item.surveyTypeId))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.surveyTypeId),
          1
        );
      else this.multiSelectionOrganizations.push(item.surveyTypeId);
    else this.multiSelectionOrganizations = [];

    console.log(this.multiSelectionOrganizations);
    let length = this.multiSelectionOrganizations.length;
    this.selctionlength = length;
    console.log(this.selctionlength);
    this.selectedOrganizationId = item.surveyTypeId;
    this.selectedOrganzation = item.surveyTypeName;

    if (item.surveyTypeName != 'All') {
      this.selectedOrganzation = this.mainSurveyTypes.find((x: { surveyTypeName: any; }) => x.surveyTypeName == this.multiSelectionOrganizations[this.multiSelectionOrganizations.length - 1]).surveyTypeName;
    } else {
      this.selectedOrganzation = item.surveyTypeName;
    }

    this.getSurveyReport();
  }


  selectOrgatizationFacility(item) {
    console.log(item);
    if (item.facilityTypeId !== null)
      if (this.multiSelectionOrganizations.includes(item.facilityTypeId))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.facilityTypeId),
          1
        );
      // else this.multiSelectionOrganizations.push(item.facilityTypeId);
      else this.multiSelectionOrganizations = item.facilityTypeId;
    else this.multiSelectionOrganizations = [];

    console.log(this.multiSelectionOrganizations);
    let length = this.multiSelectionOrganizations.length;
    this.selctionlength = length;
    console.log(this.selctionlength);
    this.selectedOrganizationId = item.facilityTypeId;
    this.selectedOrganzation = item.facilityTypeName;

    this.selectedFacilityName = item.facilityTypeName;

    if (item.facilityTypeName != 'All') {
      //this.selectedOrganzation = this.mainFacilityTypes.find((x: { facilityTypeName: any; }) => x.facilityTypeName == this.multiSelectionOrganizations[this.multiSelectionOrganizations.length - 1]).facilityTypeName;
    } else {
      //this.selectedOrganzation = item.facilityTypeName;
    }

    this.getFacilityReport();
  }

  selectOrgatizationEmployee(item) {
    console.log(item);
    if (item.employeeReportId !== null)
      if (this.multiSelectionOrganizations.includes(item.employeeReportId))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.employeeReportId),
          1
        );
      // else this.multiSelectionOrganizations.push(item.employeeReportId);
      else this.multiSelectionOrganizations = item.employeeReportId;
    else this.multiSelectionOrganizations = [];

    console.log(this.multiSelectionOrganizations);
    let length = this.multiSelectionOrganizations.length;
    this.selctionlength = length;
    console.log(this.selctionlength);
    this.selectedOrganizationId = item.employeeReportId;
    this.selectedOrganzation = item.employeeReportName;

    this.selectedEmployeeName = item.employeeReportName;

    if (item.employeeReportName != 'All') {
      //this.selectedOrganzation = this.mainFacilityTypes.find((x: { employeeReportName: any; }) => x.employeeReportName == this.multiSelectionOrganizations[this.multiSelectionOrganizations.length - 1]).employeeReportName;
    } else {
      //this.selectedOrganzation = item.employeeReportName;
    }

    this.getEmployeeReportData();
  }

  reportsList = [
    {
      index: '0',
      type: 'Credit Usage Report',
    },
    {
      index: '1',
      type: 'Check-in Report',
    },
    {
      index: '2',
      type: 'Membership Report',
    },
    {
      index: '3',
      type: 'Meeting Room - Employee Report',
    },
    {
      index: '4',
      type: 'Meeting Room - Admin Report',
    },
    {
      index: '5',
      type: 'Feedback Report',
    },
    {
      index: '6',
      type: 'VMS Report',
    },
    {
      index: '7',
      type: 'Events Report',
    },
    {
      index: '8',
      type: 'Member Card Report',
    },
    // {
    //   index: '9',
    //   type: 'Survey Report',
    // },
    // {
    //   index: '10',
    //   type: 'Facility Report',
    // },
    // {
    //   index: '11',
    //   type: 'Employee Report',
    // }
  ];

  // prodReportsList = [
  //   {
  //     index: '0',
  //     type: 'Credit Usage Report',
  //   },
  //   {
  //     index: '1',
  //     type: 'Check-in Report',
  //   },
  //   {
  //     index: '2',
  //     type: 'Membership Report',
  //   },
  //   {
  //     index: '3',
  //     type: 'Meeting Room - Employee Report',
  //   },
  //   {
  //     index: '4',
  //     type: 'Meeting Room - Admin Report',
  //   },
  //   {
  //     index: '5',
  //     type: 'Feedback Report',
  //   },
  //   {
  //     index: '6',
  //     type: 'VMS Report',
  //   },
  // ];

  prodReportsList = [
    {
      index: '0',
      type: 'Credit Usage Report',
    },
    {
      index: '1',
      type: 'Check-in Report',
    },
    {
      index: '2',
      type: 'Membership Report',
    },
    {
      index: '3',
      type: 'Meeting Room - Employee Report',
    },
    {
      index: '4',
      type: 'Meeting Room - Admin Report',
    },
    {
      index: '5',
      type: 'Feedback Report',
    },
    {
      index: '6',
      type: 'VMS Report',
    },
    {
      index: '7',
      type: 'Events Report',
    },
    {
      index: '8',
      type: 'Member Card Report',
    },
    // {
    //   index: '9',
    //   type: 'Survey Report',
    // },
    // {
    //   index: '10',
    //   type: 'Facility Report',
    // },
    // {
    //   index: '11',
    //   type: 'Employee Report',
    // }
  ];


  ngOnInit(): void {
    this.baseUrl = environment.apiBaseUrlVegitation + 'api/v1/Survey/DownloadSurveyReport?surveyId=';
    console.log(this.baseUrl);
    this.indexPage = 1;
    const route = this.sideNavService.routingChunks({ name: 'Reports' });
    this.appStateSrv.setSideNavState(route);

    const jsDate = new Date();
    this.selectedDate = this.convertDateFormat(this.datepipe.transform(jsDate, 'MM/dd/yyyy'));
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.selectedToDate = this.convertDateFormat(this.datepipe.transform(jsDate, 'MM/dd/yyyy'));
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    if (
      localStorage.getItem('reportQuery') == null ||
      localStorage.getItem('temp') != null
    ) {
      this.fromDetails = true;
    }

    if (
      localStorage.getItem('reportQuery') == null &&
      localStorage.getItem('temp') == null
    ) {
      // this.fromDetails = false;
      this.selectedTenantId = null;
      this.selectedIndex = 3;
      this.getMeetingRooms();
    } else {
      this.queryData = JSON.parse(localStorage.getItem('reportQuery'));
      const tempData = localStorage.getItem('temp');
      console.log(tempData);
      // this.fromDetails = true;
      this.selectedToDate = this.queryData
        ? this.queryData.toDate
        : new Date().getMonth() +
        1 +
        '/' +
        new Date().getDate() +
        '/' +
        new Date().getFullYear();
      this.formattedSelectedToDate = this.queryData
        ? this.dateSrv.convertDateToLocaleString(
          this.queryData.toDate.split('/')[1],
          this.queryData.toDate.split('/')[0] - 1,
          this.queryData.toDate.split('/')[2]
        )
        : this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );

      this.selectedDate = this.queryData
        ? this.queryData.fromDate
        : new Date().getMonth() +
        1 +
        '/' +
        new Date().getDate() +
        '/' +
        new Date().getFullYear();
      this.formattedSelectedDate = this.queryData
        ? this.dateSrv.convertDateToLocaleString(
          this.queryData.fromDate.split('/')[1],
          this.queryData.fromDate.split('/')[0] - 1,
          this.queryData.fromDate.split('/')[2]
        )
        : this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );

      this.selectedTenantId = this.queryData
        ? this.queryData.select == 'All'
          ? null
          : this.queryData.select
        : null;
      const type = this.queryData ? this.queryData.type : Number(tempData);

      switch (type) {
        case 0:
          this.selectedIndex = 0;
          this.getCreditReports(1);
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          this.multiSelectionCreditUsageType = [];
          this.Usagetypes = [
            { id: '1', type: 'Admin(s)' },
            { id: '3', type: 'Members' },
          ];
          this.multiSelectionCreditUsageType.push(this.Usagetypes[0].id);
          this.selectedUsageType = this.Usagetypes[0].type;
          break;
        case 1:
          this.selectedIndex = 1;
          this.getAccessPoints();
          this.getCheckInReports();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        case 2:
          this.selectedIndex = 2;
          this.getTentants();
          this.getMembershipsReport();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        case 3:
          this.selectedIndex = 3;
          this.getMeetingRooms();
          if (
            !(
              this.queryData &&
              this.queryData.roomName &&
              this.queryData.roomid
            )
          )
            this.getMeetingReports();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        case 4:
          this.selectedIndex = 4;
          this.getMeetingRooms();
          this.getMeetingReports();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        case 5:
          this.selectedIndex = 5;
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          this.multiSelectionFRType = [];
          this.FRtypes = [
            { id: '1', type: 'Meeting Room' },
            { id: '2', type: 'Employee De-Boarding' },
            { id: '3', type: 'Organisation De-Boarding' },
          ];
          this.multiSelectionFRType.push(this.FRtypes[0].id);
          this.selectedFRType = this.FRtypes[0].type;
          break;
        case 6:
          this.selectedIndex = 6;
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          this.getinvitationTypes();
          this.getVMSReports();
          break;
        case 8:
          this.selectedIndex = 8;
          this.getTentantsRfid();
          // this.getRfidsReport();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        case 9:
          this.selectedIndex = 9;
          this.getSurveyReport();
          this.getTypeSurvey();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        case 10:
          this.selectedIndex = 10;
          this.getFacilityReport();
          this.getTypeFacility();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        case 11:
          this.selectedIndex = 11;
          this.getTypeEmployeeReport();
          this.getEmployeeReportData();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        // case 6:
        //   this.selectedIndex = 6;
        //   localStorage.removeItem('reportQuery');
        //   localStorage.removeItem('temp');
        //   this.getEventType();
        //   // this.getVMSReports();
        //   break;
      }
    }
  }

  getMeetingRooms() {
    this.reportsLoaded = false;
    this.reportService.getMeetingRooms().subscribe((r) => {
      this.meetingRooms = r;
      this.selectedMeetingRoomId = null;

      const allOpt = {
        id: null,
        name: 'All',
      };
      this.meetingRooms.unshift(allOpt);
      if (
        (this.queryData && this.queryData.roomName && this.queryData.roomid) ||
        localStorage.getItem('reportQuery') !== null
      )
        this.selectMeetingRoom({
          name: this.queryData.roomName,
          id: Number(this.queryData.roomid),
        });
      // if (this.selectedMeetingRoomId == null && this.meetingRooms.length > 0 && localStorage.getItem('reportQuery') == null)
      else {
        this.selectedMeetingRoomId = this.meetingRooms[0].id;
        this.selectMeetingRoom(this.meetingRooms[0]);
      }

      this.reportsLoaded = true;
    });
  }

  getAccessPoints() {
    this.reportsLoaded = false;
    this.accessPoints = [];
    this.reportService.getAccessPoints().subscribe((r) => {
      this.accessPoints = r;
      const allOpt = {
        id: null,
        accessPointName: 'All',
      };
      this.accessPoints.unshift(allOpt);
      if (this.selectedAccessPointId == null && this.accessPoints.length > 0) {
        this.selectedAccessPointId = this.accessPoints[0].id;
        this.selectAccessPoint(this.accessPoints[0]);
      }
      this.reportsLoaded = true;
    });
  }

  getDepartments() {
    this.reportsLoaded = false;
    this.reportService.getDepartments().subscribe((r) => {
      this.departments = r;
      const allOpt = {
        id: null,
        department: 'All',
      };
      this.departments.unshift(allOpt);
      if (this.selectedDepartmentId == null && this.departments.length > 0) {
        this.selectedDepartmentId = this.departments[0].id;
        this.selectDepartment(this.departments[0]);
      }
      this.reportsLoaded = true;
    });
  }

  getTentants() {
    this.reportsLoaded = false;
    this.reportService.getTenant().subscribe((r) => {
      this.tenants = r.data.tenants;
      const allOpt = {
        id: null,
        companyName: 'All',
      };
      this.tenants.unshift(allOpt);
      if (this.selectedOrganizationId == null && this.tenants.length > 0) {
        this.selectedOrganizationId = this.tenants[0].id;
        this.selectOrgatization(this.tenants[0]);
      }
      this.reportsLoaded = true;
    });
  }

  getTentantsRfid() {
    this.reportsLoaded = false;
    this.reportService.getTenant().subscribe((r) => {
      this.tenants = r.data.tenants;
      const allOpt = {
        id: null,
        companyName: 'All',
      };
      this.tenants.unshift(allOpt);
      if (this.selectedOrganizationId == null && this.tenants.length > 0) {
        this.selectedOrganizationId = this.tenants[0].id;
        this.selectOrgatizationRfid(this.tenants[0]);
      }
      // this.reportsLoaded = true;
    });
  }

  getTypeSurvey() {
    this.reportsLoaded = false;
    this.mainSurveyTypes.push({
      surveyTypeId: "General",
      surveyTypeName: "General"
    },
      {
        surveyTypeId: "Event",
        surveyTypeName: "Event"
      }
    );
    const allOpt = {
      surveyTypeId: null,
      surveyTypeName: "All"
    }
    this.mainSurveyTypes.unshift(allOpt);
    // let length = this.mainSurveyTypes.length - 1;
    // this.selctionlength = length;
    this.selectedSurveyName = this.mainSurveyTypes[0].surveyTypeName;

    if (this.mainSurveyTypes.length > 0) {
      this.selectedOrganizationId = this.mainSurveyTypes[0].surveyTypeId;
      this.selectOrgatizationSurvey(this.mainSurveyTypes[0]);
    }
  }

  getTypeFacility() {
    this.reportsLoaded = false;
    this.mainFacilityTypes.push({
      facilityTypeId: "confirm",
      facilityTypeName: "Confirm"
    },
      {
        facilityTypeId: "cancel",
        facilityTypeName: "Cancel"
      }
    );
    const allOpt = {
      facilityTypeId: null,
      facilityTypeName: "All"
    }
    this.mainFacilityTypes.unshift(allOpt);
    // let length = this.mainFacilityTypes.length - 1;
    // this.selctionlength = length;
    this.selectedFacilityName = this.mainFacilityTypes[0].facilityTypeName;

    if (this.mainFacilityTypes.length > 0) {
      this.selectedOrganizationId = this.mainFacilityTypes[0].facilityTypeId;
      this.selectOrgatizationFacility(this.mainFacilityTypes[0]);
    }
  }

  getTypeEmployeeReport() {
    this.reportsLoaded = false;
    this.mainEmployeeTypes.push({
      employeeReportId: "2",
      employeeReportName: "With Access"
    },
      {
        employeeReportId: "3",
        employeeReportName: "Without Access"
      },
      {
        employeeReportId: "4",
        employeeReportName: "Pending Approval"
      }
    );
    const allOpt = {
      employeeReportId: "1",
      employeeReportName: "All"
    }
    this.mainEmployeeTypes.unshift(allOpt);
    // let length = this.mainEmployeeTypes.length - 1;
    // this.selctionlength = length;
    this.selectedEmployeeName = this.mainEmployeeTypes[0].employeeReportName;

    if (this.mainEmployeeTypes.length > 0) {
      this.selectedOrganizationId = this.mainEmployeeTypes[0].employeeReportId;
      this.selectOrgatizationEmployee(this.mainEmployeeTypes[0]);
    }
  }


  getVMSReports() {
    this.reportsLoaded = false;
    const totalCount = {
      invitationType: this.multiSelectionInvitationType,
      parkId: localStorage.getItem('parkId'),
      // invitationType: "individualInvite",
      // TenantId: "b8657e8d-c137-46a4-9de0-bdbb01b8fc04", //  localStorage.getItem(AppConstant.localStorage.parkTenantId);
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: 0,
      size: 0,
      isAll: this.multiSelectionInvitationType.length == 0 ? true : false,
      locationId: localStorage.getItem("locationId") ?? 1
    };
    const VMSReportInputModel = {
      invitationType: this.multiSelectionInvitationType,
      parkId: localStorage.getItem('parkId'),
      //invitationType: "individualInvite",
      // TenantId: "b8657e8d-c137-46a4-9de0-bdbb01b8fc04", //  localStorage.getItem(AppConstant.localStorage.parkTenantId);
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: this.page,
      size: this.pageSize,
      isAll: this.multiSelectionInvitationType.length == 0 ? true : false,
      locationId: localStorage.getItem("locationId") ?? 1
    };

    this.vmsService.getVMSReportBPData(totalCount).subscribe((res) => {
      this.totalVMSCount = res?.data?.length;
    });

    this.vmsService.getVMSReportBPData(VMSReportInputModel).subscribe(
      (response: any) => {
        console.log('s', response);
        this.vmsList = response.data;
        this.vmsLists = this.vmsList;
        this.reportsLoaded = true;
        this.totalRows = this.vmsList?.length;
        //   if (this.vmsList?.length > 0)
        //   this.reportsLoaded = true;
        // else
        //   this.reportsLoaded = false;
      },
      (err) => console.log('error', err)
    );
  }

  getEventsReports() {
    this.reportsLoaded = false;
    let locationId = localStorage.getItem("locationId") ?? 1;
    let body = {
      eventCategoryId: this.multiSelectionEventType,
      parkId: localStorage.getItem('parkId'),
      //invitationType: "individualInvite",
      // TenantId: "b8657e8d-c137-46a4-9de0-bdbb01b8fc04", //  localStorage.getItem(AppConstant.localStorage.parkTenantId);
      eventFromDate: this.selectedDate,
      eventToDate: this.selectedToDate,
      searchText: this.searchText,
      pageNo: 0,
      size: 0,
      // tenantId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      locationId: locationId
    }
    this.eventService.getEventsReportData(body).subscribe(res => {
      console.log(res)
      this.totalEventCount = res.list?.length
      body['pageNo'] = this.page
      body['size'] = this.pageSize
      this.eventService.getEventsReportData(body).subscribe(res => {
        this.eventList = res.list
        this.reportsLoaded = true

      });
    })
  }

  getEventType() {
    this.eventService.getEventCategory().subscribe(res => {
      console.log(res)
      this.eventType = res
      console.log(this.eventType)
      this.selectedEventTypeId = null;
      const allOpt = {
        eventCategoryId: null,
        eventCategoryName: 'All',
      };
      this.eventType.unshift(allOpt);

      if (
        this.selectedEventTypeId == null &&
        this.eventType.length > 0
      ) {
        this.selectedEventTypeId =
          this.eventType[0].eventCategoryId;
        this.selectEventType(this.eventType[0]);
      }
      // this.reportsLoaded = true;
    })
  }

  selectEventType(item) {
    console.log('item', item)
    if (item.eventCategoryId !== null)
      if (this.multiSelectionEventType.includes(item.eventCategoryId))
        this.multiSelectionEventType.splice(
          this.multiSelectionEventType.indexOf(item.eventCategoryId),
          1
        );
      else this.multiSelectionEventType.push(item.eventCategoryId);
    else {
      this.multiSelectionEventType = [];
      this.eventType.forEach(element => {
        if (element.eventCategoryId !== null)
          this.multiSelectionEventType.push(element.eventCategoryId);
      });
    }

    let length = this.multiSelectionEventType.length - 1;
    this.selctionlength = length;
    this.selectedEventTypeId = item.eventCategoryId;

    if (item.eventCategoryName != 'All') {
      if (this.multiSelectionEventType.length == this.eventType.length) {
        this.selectedEType = 'All'
      }
      else
        if (this.multiSelectionEventType.length > 1) {
          this.selectedEType = this.selectedEType = this.eventType.find(
            (x) =>
              x.eventCategoryId ==
              this.multiSelectionEventType[
              0
              ]
          ).eventCategoryName;
          this.selectedEType = this.selectedEType + ' +' + (this.multiSelectionEventType.length - 1) + ' More'
        } else {
          this.selectedEType = this.eventType.find(
            (x) =>
              x.eventCategoryId ==
              this.multiSelectionEventType[
              0
              ]
          ).eventCategoryName;
        }
    } else {
      this.selectedEType = 'All'
    }
    console.log('multiSelectionEventType', this.multiSelectionEventType)
    this.page = 1
    this.getEventsReports();
  }

  getCheckInReports() {
    this.reportsLoaded = false;
    this.checkIns = [];
    if (this.multiSelectionAccessPoints.length > 0) {
      this.reportService
        .getCheckInReports(
          this.multiSelectionAccessPoints,
          this.selectedDate,
          this.selectedToDate,
          this.selectedTenantId
        )
        .subscribe((r) => {
          if (r.length > 0) this.checkIns = [...this.checkIns, ...r];
          console.log('1st', this.checkIns);
          this.reportsLoaded = true;
          this.handlePageChangeCheckIn(1);
        });
    } else
      this.reportService
        .getCheckInReports(
          this.multiSelectionAccessPoints,
          this.selectedDate,
          this.selectedToDate,
          this.selectedTenantId
        )
        .subscribe((r) => {
          if (r.length > 0) this.checkIns = [...r];
          console.log('2', this.checkIns);
          this.reportsLoaded = true;
          this.handlePageChangeCheckIn(1);
        });
  }

  getCreditReports(id) {
    this.reportsLoaded = false;
    this.reportService
      .getCreditReports(
        this.selectedDate,
        this.selectedToDate,
        id,
        this.selectedTenantId
      )
      .subscribe((r) => {
        this.creditPoints = r;
        this.reportsLoaded = true;
        this.handlePageChangeCredit(1);
      });
  }

  getMembershipsReport() {
    this.memberships = [];

    if (this.multiSelectionOrganizations.length > 0) {
      this.reportService
        .getMemberships(
          this.multiSelectionOrganizations,
          this.selectedDate,
          this.selectedToDate
        )
        .subscribe((r) => {
          if (r.length > 0) this.memberships = [...this.memberships, ...r];
          this.reportsLoaded = true;
          this.handlePageChangeMbrshp(1);
        });
    } else
      this.reportService
        .getMemberships(null, this.selectedDate, this.selectedToDate)
        .subscribe((r) => {
          if (r.length > 0) this.memberships = [...r];
          this.reportsLoaded = true;
          this.handlePageChangeMbrshp(1);
        });
  }

  getRfidsReport() {
    this.listfrids = [];
    if (this.pageNo == 0) {
      this.pageNo = 1;
    }
    if (this.multiSelectionOrganizations.length > 0) {
      this.reportService
        .getRfids(
          this.multiSelectionOrganizations,
          this.convertDateFormat(this.selectedDate),
          this.convertDateFormat(this.selectedToDate),
          this.pageNo,
          10, //this.pageSize,
        )
        .subscribe((r) => {
          if (r.length > 0) this.listfrids = [...this.listfrids, ...r];
          this.reportsLoaded = true;
          this.handlePageChangeRfids(1);
        });
    } else {
      this.reportService
        .getRfids(null, this.convertDateFormat(this.selectedDate), this.convertDateFormat(this.selectedToDate), this.pageNo, 10)
        .subscribe((r) => {
          if (r.length > 0) this.listfrids = [...r];
          this.reportsLoaded = true;
          this.handlePageChangeRfids(1);
        });
    }
  }

  getSurveyReport() {

    this.listSurvey = [];

    console.log(this.multiSelectionOrganizations.length);

    if (this.multiSelectionOrganizations.length > 0) {
      this.reportService
        .getSurveyReport(
          this.multiSelectionOrganizations,
          this.selectedDate,
          this.selectedToDate
        )
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listSurvey = [...this.listSurvey, ...r.list];
            console.log(this.listSurvey);
            this.reportsLoaded = true;
            this.handlePageChangeSurvey(1);
          }
        });
    } else {
      this.reportService
        .getSurveyReport([], this.selectedDate, this.selectedToDate)
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listSurvey = [...r.list];
            console.log(this.listSurvey);
            this.reportsLoaded = true;
            this.handlePageChangeSurvey(1);
          } else {
            this.listSurvey = [...this.listSurvey];
            this.reportsLoaded = true;
            this.handlePageChangeSurvey(1);
          }
        });
    }

  }

  getFacilityReport() {

    this.listFacility = [];

    console.log(this.multiSelectionOrganizations.length);

    if (this.multiSelectionOrganizations.length > 0) {
      this.reportService
        .getFacilityReport(
          this.multiSelectionOrganizations,
          this.selectedDate,
          this.selectedToDate
        )
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listFacility = [...this.listFacility, ...r.list];
            console.log(this.listFacility);
            this.reportsLoaded = true;
            this.handlePageChangeFacility(1);
          }
        });
    } else {
      this.reportService
        .getFacilityReport('all', this.selectedDate, this.selectedToDate)
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listFacility = [...r.list];
            console.log(this.listFacility);
            this.reportsLoaded = true;
            this.handlePageChangeFacility(1);
          } else {
            this.listFacility = [...this.listFacility];
            this.reportsLoaded = true;
            this.handlePageChangeFacility(1);
          }
        });
    }

  }


  getEmployeeReportData() {

    this.listEmployee = [];

    console.log(this.multiSelectionOrganizations.length);

    const employeeReportRequestModel = {
      vmsAccessType: this.multiSelectionOrganizations,
      parkId: localStorage.getItem('parkId'),
      // fromDate: this.selectedDate,
      // toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: this.pageNo,
      size: 0 //this.pageSize,
    };

    if (this.multiSelectionOrganizations.length > 0) {
      this.reportService
        .getEmployeeReportsForEmp(employeeReportRequestModel)
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listEmployee = [...r.list];
            console.log(this.listEmployee);
            this.reportsLoaded = true;
            this.handlePageChangeEmployeeReport(1);
          }
        });
    } else {
      this.reportService
        .getEmployeeReportsForEmp(employeeReportRequestModel)
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listEmployee = [...r.list];
            console.log(this.listEmployee);
            this.reportsLoaded = true;
            this.handlePageChangeEmployeeReport(1);
          } else {
            this.listEmployee = [...this.listEmployee];
            this.reportsLoaded = true;
            this.handlePageChangeEmployeeReport(1);
          }
        });
    }
  }


  getEmployeeReports() {
    this.reportsLoaded = false;
    this.employees = [];
    if (this.multiSelectionDepartments.length > 0) {
      this.reportService
        .getEmployeeReports(
          this.multiSelectionDepartments,
          this.selectedDate,
          this.selectedToDate
        )
        .subscribe((r) => {
          if (r.length > 0) this.employees = [...this.employees, ...r];
          this.reportsLoaded = true;
          this.handlePageChangeEmployee(1);
        });
    } else
      this.reportService
        .getEmployeeReports(null, this.selectedDate, this.selectedToDate)
        .subscribe((r) => {
          if (r.length > 0) this.employees = [...r];
          this.reportsLoaded = true;
          this.handlePageChangeEmployee(1);
        });
  }

  getMeetingReports() {
    this.reportsLoaded = false;
    this.meetings = [];
    let meetingRoomIdList: any[] = [];
    // if ((this.queryData && this.queryData.roomName && this.queryData.roomid) || localStorage.getItem('reportQuery') !== null) {
    //   if (!this.multiSelectionMeetingRoom.includes(Number(this.queryData.roomId)))
    //     this.multiSelectionMeetingRoom.push(Number(this.queryData.roomid));
    // }

    if (this.multiSelectionMeetingRoom.length > 0) {
      this.reportService
        .getMeetingReports(
          this.multiSelectionMeetingRoom,
          this.selectedDate,
          this.selectedToDate,
          this.selectedIndex == 4 ? 1 : 3,
          this.selectedTenantId
        )
        .subscribe((r) => {
          if (r.length > 0) this.meetings = [...this.meetings, ...r];

          this.reportsLoaded = true;
          this.handlePageChangeMeeting(1);
        });
    } else
      this.reportService
        .getMeetingReports(
          null,
          this.selectedDate,
          this.selectedToDate,
          this.selectedIndex == 4 ? 1 : 3,
          this.selectedTenantId
        )
        .subscribe((r) => {
          if (r.length > 0) this.meetings = [...r];

          this.reportsLoaded = true;
          this.handlePageChangeMeeting(1);
        });
  }

  refreshPagination(e) {
    this.page = e;
  }

  //vms

  getinvitationTypes() {
    this.reportsLoaded = false;

    this.vmsService.getInvitationType().subscribe((r) => {
      this.invitationTypes = r.list;
      this.selectedInvitatoinTypeId = null;
      const allOpt = {
        invitationTypeId: null,
        invitationType: 'All',
      };
      this.invitationTypes.unshift(allOpt);

      if (
        this.selectedInvitatoinTypeId == null &&
        this.invitationTypes.length > 0
      ) {
        this.selectedInvitatoinTypeId =
          this.invitationTypes[0].invitationTypeId;
        this.selectInviteType(this.invitationTypes[0]);
      }
      this.reportsLoaded = true;
    });
  }

  selectInviteType(item) {
    if (item.invitationTypeId !== null)
      if (this.multiSelectionInvitationType.includes(item.invitationTypeId))
        this.multiSelectionInvitationType.splice(
          this.multiSelectionInvitationType.indexOf(item.invitationTypeId),
          1
        );
      else this.multiSelectionInvitationType.push(item.invitationTypeId);
    else this.multiSelectionInvitationType = [];

    let length = this.multiSelectionInvitationType.length - 1;
    this.selctionlength = length;
    this.selectedInvitatoinTypeId = item.invitationTypeId;

    if (item.invitationType != 'All') {
      this.selectedType = this.invitationTypes.find(
        (x) =>
          x.invitationTypeId ==
          this.multiSelectionInvitationType[
          this.multiSelectionInvitationType.length - 1
          ]
      ).invitationType;
    } else {
      this.selectedType = item.invitationType;
    }
    this.page = 1
    this.getVMSReports();
  }

  DownloadReport() {
    this.worksheet = null;
    let reportname;
    if (this.selectedIndex == 0) {
      this.workbook = new Workbook();
      if (this.multiSelectionCreditUsageType == 3) {
        reportname = 'CreditUsage-Employee(s) Report';
        this.worksheet = this.workbook.addWorksheet(reportname);
        this.worksheet.columns = [
          { header: 'Sr.No', key: 'SrNo', width: 10 },
          { header: 'Employee Name', key: 'EmployeeName', width: 10 },
          { header: 'Organisation Name', key: 'Organisation', width: 10 },

          { header: 'Meeting Room Name', key: 'MeetingRoomName', width: 10 },
          { header: 'Date', key: 'DateOfMeeting', width: 10 },
          { header: 'Duration', key: 'Duration', width: 10 },
          { header: 'Credit points used', key: 'CreditPointsUsed', width: 10 },
          { header: 'Status', key: 'Status', width: 10 },
        ];
      } else {
        reportname = 'CreditUsage-Admin(s) Report';
        this.worksheet = this.workbook.addWorksheet(reportname);
        this.worksheet.columns = [
          { header: 'Sr.No', key: 'SrNo', width: 10 },
          { header: 'Admin Name', key: 'BookedBy', width: 10 },
          { header: 'Employee Name', key: 'EmployeeName', width: 10 },
          { header: 'Organisation Name', key: 'Organisation', width: 10 },
          { header: 'Meeting Room Name', key: 'MeetingRoomName', width: 10 },
          { header: 'Date', key: 'DateOfMeeting', width: 10 },
          { header: 'Duration', key: 'Duration', width: 10 },
          { header: 'Credit points used', key: 'CreditPointsUsed', width: 10 },
          { header: 'Status', key: 'Status', width: 10 },
        ];
      }
      let data;
      data = this.creditPoints;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            MeetingRoomName: e.meetingRoomName,
            BookedBy: e.bookedBy,
            DateOfMeeting: e.dateOfMeeting,
            Duration: e.duration,
            EmployeeName: e.employeeName,
            Organisation: e.organisation,
            CreditPointsUsed: e.creditPointsUsed,
            Status: e.Status,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 1) {
      //this.exportAsExcelFile(this.checkIns, 'CheckIn');
      this.workbook = new Workbook();
      reportname = 'CheckIn Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'srNo', width: 10 },
        { header: 'Access Point', key: 'accessPointName', width: 10 },
        { header: 'Date', key: 'dateOfCheckIn', width: 10 },
        { header: 'Check-in Time', key: 'timeOfCheckIn', width: 10 },
        { header: 'Organisation', key: 'organisation', width: 10 },
        { header: 'Member Name', key: 'memberName', width: 10 },
        { header: 'Member Email', key: 'memberEmail', width: 10 },
      ];
      let data;
      data = this.checkIns;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            srNo: e.srNo,
            accessPointName: e.accessPointName,
            dateOfCheckIn: e.dateOfCheckIn,
            //timeOfCheckIn: this.convertTime(e.timeOfCheckIn),
            timeOfCheckIn: e.timeOfCheckIn,
            organisation: e.organisation,
            memberName: e.memberName,
            memberEmail: e.memberEmail,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 2) {
      //For memberhsip report
      this.workbook = new Workbook();
      reportname = 'Membership Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Organisation Name', key: 'organisation', width: 10 },

        { header: 'Membership Type', key: 'MemberShipType', width: 10 },
        { header: 'Start Date', key: 'StartDate', width: 10 },
        { header: 'End Date', key: 'EndDate', width: 10 },
        { header: 'No.of members', key: 'NoOfMembers', width: 10 },
        { header: 'accessPoint', key: 'accessPoint', width: 10 },
        { header: 'POC Name', key: 'PoCName', width: 10 },
        { header: 'POC Designation', key: 'PoCDesignation', width: 10 },
        { header: 'POC Mobile Number', key: 'PoCMobileNumber', width: 10 },
        { header: 'PoC Email', key: 'PoCEmail', width: 10 },
        {
          header: 'Credit Points (Alloted)',
          key: 'CreditsPointsAlloted',
          width: 10,
        },
        {
          header: 'Credit Points (Purchased)',
          key: 'CreditsPointsPurchased',
          width: 10,
        },
      ];
      let data;
      data = this.memberships;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            organisation: e.organisation,
            MemberShipType: e.memberShipType,
            StartDate: e.startDate,
            EndDate: e.endDate,
            NoOfMembers: e.noOfMembers,
            accessPoint: e.accessPoint,
            PoCName: e.pocName,
            PoCDesignation: e.pocDesignation,
            PoCMobileNumber: e.pocMobileNo,
            PoCEmail: e.pocEmail,
            CreditsPointsAlloted: e.creditPointsAllocated,
            CreditsPointsPurchased: e.creditPointsPurchased,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    } else if (this.selectedIndex == 8) {
      //For memberhsip report
      this.workbook = new Workbook();
      reportname = 'Member Card Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Organisation Name', key: 'organizationName', width: 10 },
        { header: 'Member Name', key: 'memberName', width: 10 },
        { header: 'Member Mobile', key: 'memberMobile', width: 10 },
        { header: 'Member Email', key: 'memberEmail', width: 10 },
        { header: 'Card Serial Number', key: 'memberCardNo', width: 10 },
        { header: 'Assinged On', key: 'assignedOn', width: 10 },
        { header: 'Deallocation Date', key: 'deAllocationDate', width: 10 },
      ];
      let data;
      data = this.listfrids;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            organizationName: e.organizationName,
            memberName: e.memberName ? e.memberName : '-',
            memberMobile: e.memberMobile ? e.memberMobile : '-',
            memberEmail: e.memberEmail ? e.memberEmail : '-',
            memberCardNo: e.memberCardNo,
            assignedOn: this.formatDateAll(e.assignedOn, 'date'),
            deAllocationDate: this.formatDateAll(e.deAllocationDate, 'date'),
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    } else if (this.selectedIndex == 9) {
      //For memberhsip report
      this.workbook = new Workbook();
      reportname = 'Survey Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Survey Name', key: 'surveyName', width: 10 },
        { header: 'Survey Type', key: 'surveyType', width: 10 },
        { header: 'Start Date', key: 'startDate', width: 10 },
        { header: 'End Date', key: 'endDate', width: 10 },
        // { header: 'Coupon Assinged', key: 'couponAssigned', width: 10 },
        { header: 'Park Name', key: 'parkName', width: 10 },
        { header: 'Building Name', key: 'buildingNames', width: 10 },
        { header: 'Tenant Name', key: 'tenantNames', width: 10 },
      ];
      let data;
      data = this.listSurvey;
      this.buildingData = '';
      this.tenantData = '';
      data.forEach((e, i) => {
        this.worksheet.addRow(
          {
            SrNo: i + 1,
            surveyName: e.surveyName,
            surveyType: e.surveyType,
            startDate: this.formatDateAll(e.startDate, 'date'),
            endDate: this.formatDateAll(e.endDate, 'date'),
            // couponAssigned: e.couponAssigned,
            // parkName: e.parkName,
            parkNames: e.parkNames.join(', '),
            buildingNames: e.buildingNames.join(', '),
            tenantNames: e.tenantNames.join(', '),
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    } else if (this.selectedIndex == 10) {
      //For memberhsip report
      this.workbook = new Workbook();
      reportname = 'Facility Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Faclity Name', key: 'facilityName', width: 10 },
        { header: 'Facility Type', key: 'facilityTypeName', width: 10 },
        { header: 'Facility Capacity', key: 'facilityCapacity', width: 10 },
        { header: 'Park Name', key: 'parkName', width: 10 },
        { header: 'Hourly Rate', key: 'rateHourly', width: 10 },
        { header: 'Additional Hourly Rate', key: 'additionalHourRate', width: 10 },
        { header: 'Daily Rate', key: 'dailyRate', width: 10 },
        { header: 'Additional Daily Rate', key: 'additionalDayRate', width: 10 },
        { header: 'Security Deposit', key: 'securityDeposit', width: 10 },
        { header: 'Booking Type', key: 'bookingTypeName', width: 10 },
        { header: 'Start Date', key: 'startDateTime', width: 10 },
        { header: 'End Date', key: 'endDateTime', width: 10 },
        { header: 'Duration(Hours)', key: 'duration', width: 10 },
        { header: 'Total Amount', key: 'totalAmount', width: 10 },
        { header: 'Created By', key: 'createdBy', width: 10 },
        { header: 'Payment Status', key: 'paymentStatus', width: 10 },
        { header: 'Refund Status', key: 'refundStatus', width: 10 },
      ];
      let data;
      data = this.listFacility;
      data.forEach((e, i) => {
        this.worksheet.addRow(
          {
            SrNo: i + 1,
            facilityName: e.facilityName,
            facilityTypeName: e.facilityTypeName,
            facilityCapacity: e.facilityCapacity,
            parkName: e.parkName,
            rateHourly: '₹' + e.rateHourly,
            additionalHourRate: '₹' + e.additionalHourRate,
            dailyRate: '₹' + e.dailyRate,
            additionalDayRate: '₹' + e.additionalDayRate,
            securityDeposit: '₹' + e.securityDeposit,
            bookingTypeName: e.bookingTypeName,
            startDateTime: this.formatDateAll(e.startDateTime, 'date') + ' ' + this.formatTimeAll(e.startDateTime, 'time'),
            endDateTime: this.formatDateAll(e.endDateTime, 'date') + ' ' + this.formatTimeAll(e.endDateTime, 'time'),
            duration: e.duration,
            totalAmount: '₹' + e.totalAmount,
            createdBy: e.createdBy,
            paymentStatus: e.paymentStatus,
            refundStatus: e.refundStatus,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    } else if (this.selectedIndex == 11) {
      this.workbook = new Workbook();
      reportname = 'Employee Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Company', key: 'Company', width: 10 },
        { header: 'Employee Name', key: 'EmployeeName', width: 10 },
        { header: 'Verification Status', key: 'VerificationStatus', width: 10 },
        { header: 'VMS Status', key: 'VMSStatus', width: 10 },
        { header: 'Mobile Number', key: 'MobileNumber', width: 10 },
        { header: 'Employee Email', key: 'EmployeeEmail', width: 10 },
      ];
      let data;
      // this.getEmployeeReportData();
      data = this.listEmployee;
      let srNo: number = 0;
      data.forEach((e) => {
        srNo = srNo + 1;
        this.worksheet.addRow(
          {
            SrNo: srNo,
            Company: e.companyName,
            EmployeeName: e.employeeName,
            VerificationStatus: e.verificationStatus,
            VMSStatus: e.vmsStatus,
            MobileNumber: e.mobileNumber,
            EmployeeEmail: e.employeeEmail,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 3) {
      //this.exportAsExcelFile(this.meetings, 'Meeting');
      this.workbook = new Workbook();
      reportname = 'Meeting Room Employee Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Meeting Room', key: 'meetingRoomName', width: 10 },
        { header: 'Membership type', key: 'userType', width: 10 },
        { header: 'Organization Name', key: 'organisation', width: 10 },
        { header: 'Member Name', key: 'employeeName', width: 10 },
        { header: 'Date', key: 'dateOfMeeting', width: 10 },
        { header: 'Start Time', key: 'startTime', width: 10 },
        { header: 'Duration', key: 'duration', width: 10 },
        { header: 'Status', key: 'status', width: 10 },
      ];
      let data;
      data = this.meetings;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            meetingRoomName: e.meetingRoomName,
            userType: e.userType,
            organisation: e.organisation,
            employeeName: e.employeeName,
            dateOfMeeting: e.dateOfMeeting,
            startTime: e.startTime,
            duration: e.duration + ' ' + 'hours',
            status: e.status,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 6) {
      this.workbook = new Workbook();
      console.log('vms');

      reportname = 'VMS Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'System Record Id', key: 'SystemRecordId', width: 10 },
        { header: 'Visitor Company', key: 'VisitorCompany', width: 10 },
        { header: 'Visitor Name', key: 'VisitorName', width: 10 },
        { header: 'Visitor MobileNo', key: 'VisitorMobileNumber', width: 10 },
        { header: 'Visitor Email', key: 'VisitorEmail', width: 10 },
        { header: 'InviteType', key: 'inviteType', width: 10 },
        { header: 'Visitor VehicleType', key: 'visitorVehicleType', width: 10 },
        { header: 'DateOfVisit', key: 'DateOfVisit', width: 10 },
        { header: 'Time-In', key: 'timeIn', width: 10 },
        { header: 'Time-out', key: 'timeOut', width: 10 },
        {
          header: 'Badge Returned Status',
          key: 'badgeReturnedStatus',
          width: 10,
        },
        // { header: 'Time-out', key: 'timeOut', width: 10 },
        { header: 'Host Name', key: 'HostName', width: 10 },
        { header: 'Host Mobile no', key: 'HostMobileno', width: 10 },
        { header: 'Host Email', key: 'HostEmail', width: 10 },
        { header: 'Host Company', key: 'HostCompany', width: 10 },
        // { header: 'Invite Type', key: 'inviteType', width: 10 },
        { header: 'Invite Type', key: 'invitationType', width: 10 },

        { header: 'Purpose', key: 'purpose', width: 10 },
        { header: 'Purpose Category', key: 'purposeCategory', width: 10 },

        { header: 'Park Name', key: 'ParkName', width: 10 },
        { header: 'Building', key: 'Building', width: 10 },
        { header: 'photo Id', key: 'photoId', width: 10 },
        { header: 'Gate.No', key: 'gateNo', width: 10 },
        { header: 'Status', key: 'status', width: 10 },

      ];

      let data;
      this.getVMSReports();
      data = this.vmsList;

      data.forEach((e, i) => {
        this.worksheet.addRow(
          {
            SrNo: i + 1,
            SystemRecordId: e.systemRecordId,
            VisitorCompany: e.visitorCompany,
            VisitorName: e.visitorName,
            VisitorMobileNumber: e.visitorMobileNumber,
            VisitorEmail: e.visitorEmail,
            inviteType: e.inviteType,
            visitorVehicleType: e.visitorVehicleType,
            DateOfVisit: e.dateOfVisit,
            timeIn: e.timeIn,
            timeOut: e.timeOut,
            badgeReturnedStatus: e.badgeReturnedStatus,
            HostName: e.hostName,
            HostMobileno: e.hostMobileno,
            HostEmail: e.hostEmail,
            HostCompany: e.hostCompany,
            invitationType: this.formatString(e.invitationType),
            purpose: e.purpose,
            purposeCategory: e.purposeCategory,
            ParkName: e.parkName,
            Building: e.building,
            photoId: e.photoIdType,
            gateNo: e.gateNo,
            status: this.formatString(e.invitationType) == 'Bulk Invite' ? e?.status : ''
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 4) {
      this.workbook = new Workbook();
      reportname = 'Meeting Room Admin Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Meeting Room', key: 'meetingRoomName', width: 10 },
        { header: 'Membership type', key: 'userType', width: 10 },
        { header: 'Organization Name', key: 'organisation', width: 10 },
        { header: 'Admin Name', key: 'bookedBy', width: 10 },
        { header: 'Member Name', key: 'employeeName', width: 10 },
        { header: 'Date', key: 'dateOfMeeting', width: 10 },
        { header: 'Start Time', key: 'startTime', width: 10 },
        { header: 'Duration', key: 'duration', width: 10 },
        { header: 'Status', key: 'status', width: 10 },
      ];
      let data;
      data = this.meetings;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            bookedBy: e.bookedBy,
            meetingRoomName: e.meetingRoomName,
            userType: e.userType,
            organisation: e.organisation,
            employeeName: e.employeeName,
            dateOfMeeting: e.dateOfMeeting,
            startTime: e.startTime,
            duration: e.duration + ' ' + 'hours',
            status: e.status,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 7) {
      this.workbook = new Workbook();

      reportname = 'Events Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Event Title', key: 'EventTitle', width: 10 },
        { header: 'Event Category', key: 'EventCategory', width: 10 },
        { header: 'Park Name', key: 'ParkName', width: 10 },

        {
          header: 'Event Participation Type',
          key: 'EventParticipantType',
          width: 10,
        },
        { header: 'Event Start Date', key: 'startDate', width: 10 },
        { header: 'Event End Date', key: 'endDate', width: 10 },
        // { header: 'Participant Type', key: 'ParticipantType', width: 10 },

        // { header: 'Team Name', key: 'TeamName', width: 10 },
        // {
        //   header: 'Count of Participants',
        //   key: 'ParticipantsCount',
        //   width: 10,
        // },
        {
          header: 'Attendee Company',
          key: 'ParticipantsCompany',
          width: 10,
        },
        // { header: 'Captian Name', key: 'CaptainName', width: 10 },
        // { header: 'Captian Mobile no', key: 'CaptainPhone', width: 10 },
        // { header: 'Captian Email', key: 'CaptainEmail', width: 10 },
        { header: 'Attendee Name(s)', key: 'Participants', width: 10 },
        { header: 'Attendee Email(s)', key: 'ParticipantsEmail', width: 10 },
        { header: 'Attendee Phone Number(s)', key: 'ParticipantsNumber', width: 10 },

        { header: 'Attendance', key: 'Attendance', width: 10 },
        // { header: 'Feedback', key: 'Feedback', width: 10 },
        { header: 'event Initiated By', key: 'EventinitiatedBy', width: 10 },
        { header: 'Location', key: 'Location', width: 10 },

      ];

      let data;
      this.getEventsReports();
      data = this.eventList;
      let srNo: number = 0;
      data.forEach((e) => {
        srNo = srNo + 1;
        this.worksheet.addRow(
          {
            SrNo: srNo,
            EventTitle: e.eventTitle,
            EventCategory: e.eventCategory,
            ParkName: e.parkName,
            EventParticipantType: e.eventParticipantType,
            startDate: e.startDate,
            endDate: e.endDate,
            // ParticipantType: e.participantType,
            // TeamName: e.teamName,
            // ParticipantsCount: e.participantsCount,
            ParticipantsCompany: e.participantsCompany,
            // CaptainName: e.captain?.name,
            // CaptainPhone: e.captain?.phone,
            // CaptainEmail: e.captain?.email,
            Participants: e.participants,
            ParticipantsEmail: e.participantsEmail,
            ParticipantsNumber: e.phoneNumber,
            Attendance: e.attendance,
            // Feedback: e.feedback,
            EventinitiatedBy: e.eventCreatedBy,
            Location: e?.location
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    }
  }

  exportExcel(workbook, data, ReportName) {
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(blob, ReportName);
    });
  }

  DownloadReportPDF() {
    this.PdfReportrows = [];
    if (this.selectedIndex == 0) {
      let head;
      if (this.multiSelectionCreditUsageType == 3) {
        head = [
          [
            'Sr.No',
            'Employee Name',
            'Organisation Name',
            'Meeting Room Name',
            'Date',
            'Duration',
            'Credit points used',
            'Status',
          ],
        ];
        this.creditPoints.forEach((element) => {
          var temp = [
            element.srNo,
            element.employeeName,
            element.organisation,
            element.meetingRoomName,
            element.dateOfMeeting,
            element.duration + ' ' + 'hours',
            element.creditPointsUsed,
            element.status,
          ];
          this.PdfReportrows.push(temp);
        });
        this.openPDF(
          this.PdfReportrows,
          'CreditPoint Members Report',
          head,
          'p'
        );
      } else if (this.multiSelectionCreditUsageType == 1) {
        head = [
          [
            'Sr.No',
            'Admin Name',
            'Employee Name',
            'Organisation Name',
            'Meeting Room Name',
            'Date',
            'Duration',
            'Credit points used',
            'Status',
          ],
        ];
        this.creditPoints.forEach((element) => {
          var temp = [
            element.srNo,
            element.bookedBy,
            element.employeeName,
            element.organisation,
            element.meetingRoomName,
            element.dateOfMeeting,
            element.duration + ' ' + 'hours',
            element.creditPointsUsed,
            element.status,
          ];
          this.PdfReportrows.push(temp);
        });
        this.openPDF(
          this.PdfReportrows,
          'CreditPoint Admin(s) Report',
          head,
          'p'
        );
      }
    } else if (this.selectedIndex == 1) {
      let head = [
        [
          'Sr.No',
          'Access Point',
          'Date',
          'Check-in Time',
          'Organisation',
          'Member Name',
          'Member Email',
        ],
      ];
      this.checkIns.forEach((element) => {
        var temp = [
          element.srNo,
          element.accessPointName,
          element.dateOfCheckIn,
          //this.convertTime(element.timeOfCheckIn),
          element.timeOfCheckIn,
          element.organisation,
          element.memberName,
          element.memberEmail,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'CheckIn Report', head, 'p');
    } else if (this.selectedIndex == 2) {
      let head = [
        [
          'Sr.No',
          'Organisation Name',
          'Membership Type',
          'Start Date',
          'End Date',

          'No.of members',
          'Access Point',
          'POC Name',
          'POC Designation',
          'POC Mobile Number',
          'POC Email',
          'Credit Points (Alloted)',
          'Credit Points (Purchased)',
        ],
      ];
      this.memberships.forEach((element) => {
        var temp = [
          element.srNo,
          element.organisation,
          element.memberShipType,
          element.startDate,
          element.endDate,
          element.noOfMembers,
          element.accessPoint,
          element.pocName,
          element.pocDesignation,
          element.pocMobileNo,
          element.pocEmail,
          element.creditPointsAllocated,
          element.creditPointsPurchased,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Membership Report', head, 'l');
    } else if (this.selectedIndex == 8) {
      let head = [
        [
          'Sr.No',
          'Organisation Name',
          'Member Name',
          'Member Mobile',
          'Member Email',
          'Card Serial Number',
          'Assinged On',
          'Deallocation Date'
        ],
      ];
      this.listfrids.forEach((element) => {
        var temp = [
          element.srNo,
          element.organizationName,
          element.memberName ? element.memberName : '-',
          element.memberMobile ? element.memberMobile : '-',
          element.memberEmail ? element.memberEmail : '-',
          element.memberCardNo,
          element.assignedOn,
          this.formatDateAll(element.assignedOn, 'date'),
          this.formatDateAll(element.deAllocationDate, 'date'),
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Member Card Report', head, 'l');
    } else if (this.selectedIndex == 9) {
      let head = [
        [
          'Sr.No',
          'Survey Name',
          'Survey Type',
          'Start Date',
          'End Date',
          // 'Coupon Assinged',
          'Park Name',
          'Building Name',
          'Tenant Name',
        ],
      ];
      this.listSurvey.forEach((element, i) => {
        var temp = [
          i + 1,
          element.surveyName,
          element.surveyType,
          this.formatDateAll(element.startDate, 'date'),
          this.formatDateAll(element.endDate, 'date'),
          // element.couponAssigned,
          // element.parkName,
          element.parkNames.join(', '),
          element.buildingNames.join(', '),
          element.tenantNames.join(', '),
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Survey Report', head, 'l');
    } else if (this.selectedIndex == 10) {
      let head = [
        [
          'Sr.No',
          'Faclity Name',
          'Facility Type',
          'Facility Capacity',
          'Park Name',
          'Hourly Rate',
          'Additional Hourly Rate',
          'Daily Rate',
          'Additional Daily Rate',
          'Security Deposit',
          'Booking Type',
          'Start Date',
          'End Date',
          'Duration(Hours)',
          'Total Amount',
          'Created By',
          'Payment Status',
          'Refund Status'
        ],
      ];
      this.listFacility.forEach((element, i) => {
        var temp = [
          i + 1,
          element.facilityName,
          element.facilityTypeName,
          element.facilityCapacity,
          element.parkName,
          '₹' + element.rateHourly,
          '₹' + element.additionalHourRate,
          '₹' + element.dailyRate,
          '₹' + element.additionalDayRate,
          '₹' + element.securityDeposit,
          element.bookingTypeName,
          this.formatDateAll(element.startDateTime, 'date') + ' ' + this.formatTimeAll(element.startDateTime, 'time'),
          this.formatDateAll(element.endDateTime, 'date') + ' ' + this.formatTimeAll(element.endDateTime, 'time'),
          element.duration,
          '₹' + element.totalAmount,
          element.createdBy,
          element.paymentStatus,
          element.refundStatus,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Facility Report', head, 'l');
    } else if (this.selectedIndex == 11) {
      let head;

      head = [
        [
          'Sr.No',
          'Company',
          'Employee Name',
          'Verification Status',
          'VMS Status',
          'Mobile Number',
          'Employee Email',
        ],
      ];
      // this.getEmployeeReportData();
      let srNo: number = 0;
      this.listEmployee.forEach((element) => {
        srNo = srNo + 1;
        var temp = [
          srNo,
          element.companyName,
          element.employeeName,
          element.verificationStatus,
          element.vmsStatus,
          element.mobileNumber,
          element.employeeEmail,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(
        this.PdfReportrows,
        'Employee Report',
        head,
        '1'
      );
    } else if (this.selectedIndex == 6) {
      let head;

      head = [
        [
          'Sr.No',
          'System Record Id',
          'Visitor Company',
          'Visitor Name',
          'Visitor MobileNo',
          'Visitor Email',
          'Invite Type',
          'Visitor VehicleType',
          'DateOfVisit',
          'Time-In',
          'Time-Out',
          'Badge Returned Status',
          'Host Name',
          'Host Mobile no',
          'Host Email',
          'Host Company',
          'Invitation Type',
          'Purpose',
          'Purpose Category',
          'Park Name',
          'Building',
          'Photo Id',
          'GateNo',
          'Status'
        ],
      ];
      this.getVMSReports();
      this.vmsList.forEach((e, i) => {
        var temp = [
          i + 1,
          e.systemRecordId,
          e.visitorCompany,
          e.visitorName,
          e.visitorMobileNumber,
          e.visitorEmail,
          e.inviteType,
          e.visitorVehicleType,
          e.dateOfVisit,
          e.timeIn,
          e.timeOut,
          e.badgeReturnedStatus,
          e.hostName,
          e.hostMobileno,
          e.hostEmail,
          e.hostCompany,
          this.formatString(e.invitationType),
          e.purpose.replace(/^\s+|\s+$/gm, ''),
          e.purposeCategory,
          e.parkName,
          e.building,
          e.photoIdType,
          e.gateNo,
          this.formatString(e.invitationType) == 'Bulk Invite' ? e?.status : ''
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'VMS Report', head, 'l');
    } else if (this.selectedIndex == 3) {
      let head = [
        [
          'Sr.No',
          'Meeting Room',
          'Membership type',
          'Organization Name',
          'Member Name',
          'Date',
          'Start Time',
          'Duration',
          'Status',
        ],
      ];
      this.meetings.forEach((element) => {
        var temp = [
          element.srNo,
          element.meetingRoomName,
          element.userType,
          element.organisation,
          element.employeeName,
          element.dateOfMeeting,
          element.startTime,
          element.duration + ' ' + 'hours',
          element.status,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Meeting Room Report', head, 'l');
    } else if (this.selectedIndex == 4) {
      let head = [
        [
          'Sr.No',
          'Meeting Room',
          'Membership type',
          'Organization Name',
          'Admin Name',
          'Member Name',
          'Date',
          'Start Time',
          'Duration',
          'Status',
        ],
      ];
      this.meetings.forEach((element) => {
        var temp = [
          element.srNo,
          element.meetingRoomName,
          element.userType,
          element.organisation,
          element.bookedBy,
          element.employeeName,
          element.dateOfMeeting,
          element.startTime,
          element.duration + ' ' + 'hours',
          element.status,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Meeting Room Report', head, 'l');
    } else if (this.selectedIndex == 7) {
      let head;

      head = [
        [
          'Sr.No',
          'Event Title',
          'Event Category',
          'Park',
          'Participation Type',
          'Event Start Date',
          'Event End Date',
          // 'Event Participation Type',
          // 'Team Name',
          // 'Count of Participants',
          'Attendee Company',
          // 'Participant Captain Name',
          // 'Captain’s Contact Number',
          // 'Captian Email',
          'Attendee Name(s)',
          'Attendee Email(s)',
          'Attendee Phone Number(s)',
          'Attendance',
          // 'Feedback',
          'Event initiated By',
          'Location'
        ],
      ];
      this.getEventsReports();
      let srNo: number = 0;
      this.eventList.forEach((element) => {
        srNo = srNo + 1;
        var temp = [
          srNo,
          element?.eventTitle,
          element?.eventCategory,
          element?.parkName,
          element?.participantType,
          element?.startDate,
          element?.endDate,
          // element?.eventParticipantType,
          // element?.teamName,
          // element?.participantsCount,
          element?.participantsCompany,
          // element?.captain?.name,
          // element?.captain?.phone,
          // element?.captain?.email,
          element?.participants,
          element?.participantsEmail,
          element?.phoneNumber,
          element?.attendance,
          // element?.feedback,
          element?.eventCreatedBy,
          element?.location
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Events Report', head, 'l');
    }
  }
  // openPDF(data, reportname, Head, orientation): void {
  //   var doc = new jsPDF({ orientation: orientation });
  //   doc.setFontSize(18);
  //   doc.text(reportname, 11, 8);
  //   doc.setFontSize(11);
  //   doc.setTextColor(100);
  //   (doc as any).autoTable({
  //     head: Head,
  //     body: data,
  //     columnWidth: '50%',
  //     theme: 'plain',
  //     styles: { cellWidth: 'auto', minCellWidth: 21 },
  //     didDrawCell: (data) => { },
  //   });

  openPDF(data, reportname, Head, orientation): void {
    var doc = new jsPDF({ orientation: orientation });
    doc.setFontSize(18);
    doc.text(reportname, 11, 8);
    doc.setFontSize(11);
    doc.setTextColor(100);
    autoTable(doc, {
      head: Head,
      body: data,
      theme: 'plain',
      styles: { minCellWidth: 12, overflow: 'linebreak' },
      tableWidth: 'auto',
      didDrawCell: () => { },
    });

    const safeFilename = String(reportname).replace(/[/\\.<>:"|?*]/g, '_');
    doc.output('dataurlnewwindow');
    doc.save(safeFilename + new Date().getTime());
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + new Date().getTime() + this.EXCEL_EXTENSION
    );
  }

  getPageLength() {
    if (!this.reportsLoaded) return 0;
    if (this.selectedIndex == 4) return this.meetings.length;
    if (this.selectedIndex == 3) return this.meetings.length;
    if (this.selectedIndex == 2) return this.employees.length;
    if (this.selectedIndex == 1) return this.checkIns.length;
    if (this.selectedIndex == 0) return this.creditPoints.length;
    if (this.selectedIndex == 6) return this.vmsLists.length;
    if (this.selectedIndex == 8) return this.listfrids.length;
    if (this.selectedIndex == 9) return this.listSurvey.length;
    if (this.selectedIndex == 10) return this.listFacility.length;
    if (this.selectedIndex == 11) return this.listEmployee.length;
  }

  handlePageChangeMeeting(event) {
    this.page = event;
    console.log('pagination clicked');
    // this.meetingRoom = this.meetingRooms.map(
    //   (meeting: any, i: any) => ({ id: i + 1, ...meeting })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.meeting = this.meetings.slice(
      0,
      this.meetings.length < 10
        ? this.meetings.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeEmployee(event) {
    this.page = event;
    console.log('pagination clicked');
    // this.employee = this.employees.map(
    //   (dept: any, i: any) => ({ id: i + 1, ...dept })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.employee = this.employees.slice(
      0,
      this.employees.length < 10
        ? this.employees.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeCheckIn(event) {
    this.page = event;
    console.log('pagination clicked');
    // this.accessPoint = this.accessPoints.map(
    //   (access: any, i: any) => ({ id: i + 1, ...access })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.checkIn = this.checkIns.slice(
      0,
      this.checkIns.length < 10
        ? this.checkIns.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeCredit(event) {
    this.page = event;
    console.log('pagination clicked');

    this.creditPoint = this.creditPoints.slice(
      0,
      this.creditPoints.length < 10
        ? this.creditPoints.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeVMS(event) {
    this.page = event;
    this.getVMSReports();
    // console.log('pagination clicked');

    // this.vmsList = this.vmsLists.slice(
    //   0,
    //   this.vmsLists.length < 10
    //     ? this.vmsLists.length
    //     : (this.page - 1) * this.pageSize + this.pageSize
    // );
  }

  handlePageChangeEvent(event) {
    this.page = event;
    this.getEventsReports();
  }

  handlePageChangeMbrshp(event) {
    this.page = event;
    console.log('pagination clicked');

    this.creditPoint = this.memberships.slice(
      0,
      this.memberships.length < 10
        ? this.memberships.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeRfids(event) {
    this.page = event;
    this.pageNo = event;
    console.log('pagination clicked');

    this.creditPoint = this.listfrids.slice(
      0,
      this.listfrids.length < 10
        ? this.listfrids.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeSurvey(event) {
    this.page = event;
    this.indexPage = this.page;
    console.log('pagination clicked');

    console.log(this.listSurvey);

    this.creditPoint = this.listSurvey.slice(
      0,
      this.listSurvey.length < 10
        ? this.listSurvey.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeFacility(event) {
    this.page = event;
    this.indexPage = this.page;
    console.log('pagination clicked');

    console.log(this.listFacility);

    this.creditPoint = this.listFacility.slice(
      0,
      this.listFacility.length < 10
        ? this.listFacility.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeEmployeeReport(event) {
    this.page = event;
    this.indexPage = this.page;
    console.log('pagination clicked');

    console.log(this.listEmployee);

    this.creditPoint = this.listEmployee.slice(
      0,
      this.listEmployee.length < 10
        ? this.listEmployee.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  // listEmployee
  // listfrids
  //convertTime(time) {
  //this.hour = time.split(':')[0];
  //this.min = time.split(':')[1];
  //if (this.hour > 12) {
  //this.meridiem = 'pm';
  //} else this.meridiem = 'am';
  //this.time = this.hour + ':' + this.min + ' ' + this.meridiem;
  //return this.time;
  // }
  resetDate(id) {
    this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    localStorage.setItem('temp', id);
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();
    window.location.reload();
  }


  getTotal(size) {
    return Math.ceil(size / this.pageSize)
  }

  formatString(data) {
    console.log(data)
    if (data !== null && data !== undefined) {
      let trimmedData = JSON.stringify(data.replace(/ /g, ''));

      if (trimmedData.substring(trimmedData.length - 7) == 'Invite"')
        return JSON.parse(trimmedData.substring(0, trimmedData.length - 7) + ' ' + trimmedData.substring(trimmedData.length - 7));
      return data;
    }
  }

  paginationCount(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  formatDateAll(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type
    }
  }

  formatTimeAll(date, type) {
    if (date == null) return;
    if (type == 'time') {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type
    }
    else {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
  }

  reportDownloadUrl(surveyId) {
    return this.baseUrl + surveyId;
  }

  fetchPage(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  convertDateFormat(dateString) {
    // Split the date string by '/'
    var parts = dateString.split('/');

    // Ensure month and day components are zero-padded if necessary
    var month = parts[0].padStart(2, '0');
    var day = parts[1].padStart(2, '0');
    var year = parts[2];

    // Return the formatted date string
    return month + '/' + day + '/' + year;
  }
}
